import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Footer from '../components/footer';
import JsonData from '../data/data.json';
// FontAwesome imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFingerprint } from '@fortawesome/free-solid-svg-icons';

const DemoPage = () => {
  const { productId } = useParams();
  const landingPageData = JsonData;

  // Product data mapping
  const productData = {
    'hr-management': {
      title: 'HR Management Portal',
      description: 'Streamline employee management with automated payroll, attendance tracking, and performance evaluation systems.',
      image: '/img/sevices/hr-main.jpg',
      features: [
        'Biometric Attendance',
        'Complete Employee Data Record',
        'Auto-Generated Appointment Letters',
        'Over/Less Time Report',
        'Leave Management',
        'Loan Instalment Records',
        'Auto Salary/Payroll Sheet',
        'Allowance & Deductions Calculations',
        'Office Equipment Record',
        'Employee Self Portals',
        'Print Reports in PDF/Excel',
        'Multiple Users'
      ],
      demoContent: 'Experience our comprehensive HR management solution designed to streamline all aspects of human resource operations. From employee onboarding to payroll processing, our system provides everything you need to manage your workforce efficiently.',
      detailedInfo: {
        overview: "ZipAccounts HRM is an advanced technology solution designed to assist HR professionals in managing various HR functions effectively. It encompasses tools and systems that facilitate tasks such as Employee Attendance, Payroll/Salary management, Employee Data Management, Leave & Loan Management, and Office Equipment Management. With its real-time biometric attendance recording feature, employers can access the most up-to-date information regarding their employees' attendance. This system also generates customizable reports, offering valuable insights into attendance trends and patterns for employers. The integration with payroll sheets simplifies salary calculations and enables seamless payroll processing. Additionally, ZipAccounts provides employee self-service portals, empowering employees to view their attendance records, apply for leave or out-of-office duties, and submit loan requests. With its mobile-friendly interface, employees can conveniently mark their attendance using their smartphones. Embrace the efficiency and convenience of ZipAccounts HRM for effective human resource management.",
        tagline: "Pakistan's No 1 HR Management Solution with Biometric Attendance",
        subtitle: "Are you still manually managing your employees' attendance and salary sheets? Don't worry, ZipAccounts's HR management solution can help you automate your HR processes with accuracy and authenticity.",
        attendanceFeature: "ZipAccounts offers a biometric attendance feature that provides real-time and highly accurate attendance tracking with multiple attendance reports & simplifies excess or less time calculations.",
        detailedFeatures: [
          'Biometric Attendance',
          'Complete Employee Data Record',
          'Auto-Generated Appointment Letters',
          'Over/Less Time Report',
          'Leave Management',
          'Loan Instalment Records',
          'Auto Salary/Payroll Sheet',
          'Allowance & Deductions Calculations',
          'Office Equipment Record',
          'Employee Self Portals',
          'Print Reports in PDF/Excel',
          'Multiple Users'
        ]
      }
    },
    'travel-agency': {
      title: 'Travel Agency Accounting Software',
      description: 'Specialized financial management for travel agencies with tour package costing, commission tracking, and multi-currency support.',
      image: '/img/sevices/travel_agency.png',
      features: [
        'Tour Package Costing',
        'Commission Tracking',
        'Multi-currency Support',
        'Booking Management',
        'Customer Database',
        'Vendor Management',
        'Financial Reporting',
        'Tax Compliance',
        'Invoice Generation',
        'Profit Analysis',
        'Automated Invoice Generation',
        'Real-Time Financial Dashboard',
        'User Role Management',
        'Customizable Reports',
        'Audit Trail & Logs'
      ],
      demoContent: 'Discover our specialized accounting solution tailored specifically for travel agencies. Manage tour packages, track commissions, handle multiple currencies, and maintain comprehensive financial records all in one integrated platform.'
    },
    'inventory-management': {
      title: 'Inventory Management Software',
      description: 'Real-time stock monitoring with barcode scanning, reorder alerts, and multi-location warehouse support.',
      image: '/img/sevices/inventory_main.jpg',
      features: [
        'Real-time Stock Monitoring',
        'Barcode Scanning',
        'Reorder Alerts',
        'Multi-location Warehouse Support',
        'Stock Movement Tracking',
        'Supplier Management',
        'Purchase Order Management',
        'Inventory Valuation',
        'Stock Reports',
        'Automated Reordering'
      ],
      demoContent: 'Explore our advanced inventory management system that provides real-time visibility into your stock levels across multiple locations. With barcode scanning and automated alerts, you\'ll never run out of stock again.'
    },
    'ecommerce': {
      title: 'E-commerce Software',
      description: 'Automated financial tracking for online stores with marketplace integration and tax compliance features.',
      image: '/img/sevices/e-commerce.jpg',
      features: [
        'Online Store Management',
        'Marketplace Integration',
        'Order Processing',
        'Payment Gateway Integration',
        'Tax Compliance',
        'Customer Management',
        'Product Catalog',
        'Sales Analytics',
        'Shipping Management',
        'Financial Tracking'
      ],
      demoContent: 'See how our e-commerce solution can transform your online business. From order processing to financial tracking, our integrated platform handles all aspects of your digital storefront.'
    },
    'general-accounting': {
      title: 'General Accounting Software',
      description: 'Comprehensive financial solution for SMEs with invoicing, expense tracking, and financial reporting.',
      image: '/img/sevices/genral_main.jpg',
      features: [
        'General Ledger Management',
        'Accounts Payable & Receivable',
        'Invoice Generation',
        'Expense Tracking',
        'Financial Reporting',
        'Bank Reconciliation',
        'Tax Management',
        'Multi-currency Support',
        'Chart of Accounts',
        'Audit Trail'
      ],
      demoContent: 'Experience our comprehensive accounting solution designed for small and medium enterprises. From basic bookkeeping to advanced financial reporting, our system grows with your business.'
    }
  };

  const product = productData[productId];

  if (!product) {
    return (
      <div className="demo-page">
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div className="error-content">
            <h1>Product Not Found</h1>
            <p>The requested product demo is not available.</p>
            <Link to="/" className="btn-back">Back to Home</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="demo-page">
      {/* Hero Section */}
      <section className="demo-hero">
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div className="demo-hero-content">
            <div className="demo-hero-text">
              <h1>{product.title}</h1>
              <p className="demo-description">{product.description}</p>
              <div className="demo-actions">
                <button 
                  className="btn-demo-primary"
                  onClick={() => {
                    // Store the product info in localStorage for the registration form
                    localStorage.setItem('demoRequest', JSON.stringify({
                      product: product.title,
                      productId: productId,
                      timestamp: new Date().toISOString()
                    }));
                    // Redirect to registration page with demo request
                    window.location.href = '/register?demo=true';
                  }}
                >
                  Request Live Demo
                </button>
                <button 
                  className="btn-demo-secondary"
                  onClick={() => {
                    // For now, show an alert. You can implement actual brochure download later
                    alert('Brochure download feature will be available soon!');
                  }}
                >
                  Download Brochure
                </button>
              </div>
            </div>
            <div className="demo-hero-image">
              {productId === 'inventory-management' ? (
                <img src="/img/Demos/Inventory1.jpg" alt={product.title} />
              ) : productId === 'ecommerce' ? (
                <img src="/img/Demos/ECOM1.png" alt={product.title} />
              ) : (
                <img src={product.image} alt={product.title} />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="demo-features">
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <h2>Key Features</h2>
          <div className="features-grid">
            {product.features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <i className="fa fa-check-circle"></i>
                </div>
                <h3>{feature}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Demo Content Section */}
      <section className="demo-content">
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div className="demo-content-wrapper">
            <div className="demo-content-text">
              <h2>Experience the Power</h2>
              <p>{product.demoContent}</p>
              <div className="demo-benefits">
                <div className="benefit-item">
                  <i className="fa fa-rocket"></i>
                  <span>Fast Implementation</span>
                </div>
                <div className="benefit-item">
                  <i className="fa fa-shield"></i>
                  <span>Secure & Reliable</span>
                </div>
                <div className="benefit-item">
                  <i className="fa fa-clock-o"></i>
                  <span>24/7 Support</span>
                </div>
              </div>
            </div>
            <div className="demo-content-image">
              {productId === 'hr-management' ? (
                <img src="/img/Demos/HR1.jpg" alt="HR Management Experience" />
              ) : productId === 'travel-agency' ? (
                <img src="/img/Demos/Travel1.jpg" alt="Travel Agency Experience" />
              ) : (
                <img src={product.image} alt={`${product.title} Interface`} />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="demo-cta">
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div className="cta-content">
            <h2>Ready to Get Started?</h2>
            <p>Join thousands of businesses that trust our solutions</p>
            <div className="cta-buttons">
              <Link to="/register" className="btn-cta-primary">Start Free Trial</Link>
              <Link to="/contact" className="btn-cta-secondary">Contact Sales</Link>
            </div>
          </div>
        </div>
      </section>

      {/* E-commerce Store Detailed Info Section */}
      {productId === 'ecommerce' && (
        <section className="demo-detailed-info">
          <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
            <div className="detailed-info-content">
              <div className="info-header">
                <h2>E-commerce Store Online Accounting Software</h2>
              </div>
              <div className="info-overview">
                <p>
                  ZipAccounts offers a user-friendly, easy-to-use online accounting and management web application for E-commerce businesses in Pakistan. The application is built with advanced, secure technology and features an intuitive interface designed specifically for online stores. With ZipAccounts, e-commerce owners can efficiently manage their sales, inventory, and finances using a robust double-entry system.<br/><br/>
                  <b>Main Features of ZipAccounts E-commerce Store Accounting Module:</b> Chart of Accounts, Customer & Vendor Management, Product Catalog, Order & Payment Tracking, Sales & Purchase Vouchers, Inventory Management, Daily Sales & Purchase Reports, Monthly Profit & Loss Reports, Tax Compliance, Multi-User Access, Marketplace Integration, and much more. The platform is mobile-friendly, allowing you to manage your store anytime, anywhere.
                </p>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* General Accounting Detailed Info Section */}
      {productId === 'general-accounting' && (
        <section className="demo-detailed-info">
          <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
            <div className="detailed-info-content">
              <div className="info-header">
                <h2>General Accounting Online Software</h2>
              </div>
              <div className="info-overview">
                <p>
                  ZipAccounts provides a comprehensive online accounting solution tailored for small and medium enterprises (SMEs) in Pakistan. The platform is designed to simplify financial management, offering a full suite of tools for bookkeeping, invoicing, expense tracking, and financial reporting. With its intuitive interface and secure infrastructure, businesses can efficiently manage their accounts and ensure compliance with local regulations.<br/><br/>
                  <b>Main Features of ZipAccounts General Accounting Module:</b> General Ledger Management, Accounts Payable & Receivable, Invoice Generation, Expense Tracking, Financial Reporting, Bank Reconciliation, Tax Management, Multi-currency Support, Chart of Accounts, Audit Trail, and more. The software is accessible from any device, making it easy to manage your finances on the go.
                </p>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Inventory Management Detailed Demo Section */}
      {productId === 'inventory-management' && (
        <section className="demo-detailed-info">
          <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
            <div className="detailed-info-content">
              <div className="info-header">
                <h2>Online Inventory Accounts Software</h2>
              </div>
              <div className="info-overview">
                <p>ZipAccounts provides an intuitive and easy-to-use online inventory management accounting software, tailored for businesses in Pakistan. This secure and advanced platform offers a streamlined interface that simplifies inventory and accounting tasks. It enables businesses to improve efficiency and save time by utilizing an accurate double-entry system for managing their operations seamlessly.</p>
                <p>ZipAccounts delivers a highly spontaneous and user-friendly online inventory management accounting software, precisely designed to cater to businesses across Pakistan. This state-of-the-art, secure platform offers a sophisticated yet straightforward interface that simplifies complex inventory and accounting tasks. By leveraging advanced technology and a reliable double-entry system, ZipAccounts enables businesses to streamline their operations, enhance productivity, and achieve greater accuracy in financial management. The software's thoughtful design and robust functionality ensure that users can manage their inventory efficiently, track transactions in real-time, and maintain precise financial records with ease. With ZipAccounts, businesses can expect a seamless experience that saves time and optimizes operational workflows.</p>
                <p>The Inventory Online Accounting Solutions cover below features: Chart of Accounts, Party Ledgers, Purchase & Sale Vouchers, Inventory Management, Daily Purchase & Sale Report, Monthly Profit & Loss Report, Income and Expense Report, Multiple Users Access, and much more. The application is mobile-friendly, allowing access anytime, anywhere for seamless management.</p>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Travel Agency Detailed Info Section */}
      {productId === 'travel-agency' && (
        <>
          <section className="demo-detailed-info">
            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
              <div className="detailed-info-content">
                <div className="info-header">
                  <h2>Travel Agency Online Accounting Software</h2>
                </div>
                <div className="info-overview">
                  <p>
                    E voucher offers a user friendly easy to use online accounting web application for Travel Agents & Travel Agencies in Pakistan. The application drives through most Advanced, Secure, Edge cutting technology with easy to use interface specially designed for travel agents. A Travel Agent can save its time & can perform his job more efficiently with ZipAccounts online accounts software having double entry system.<br/><br/>
                    <b>Some of the Main Features of ZipAccounts Travel Agency Accounting Module mentioned below:</b> Chart of Accounts, Customers/Vendors/Airlines/BSP/Company Accounts Creation, Trial Balance, Journal Voucher, Cash Vouchers, Expense Vouchers, Bank Vouchers, BSP Sales Management, Sales Report, Ticket voucher, Hotel Vouchers, Visa Vouchers, XO Sales, Airline Wise Reports, Sales Management, Monthly Profit & Loss Report, Multiple Users Access, Consultant Wise Sale Report, Multi Vouchers Invoice, Foreign Payment Voucher, Foreign Received Voucher, Mobile Firendly, Can be use anytime, anywhere & Much More.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </>
      )}

      {/* Detailed Information Section - Only for HR Management */}
      {productId === 'hr-management' && product.detailedInfo && (
        <>
          {/* Overview Section */}
          <section className="demo-detailed-info">
            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
              <div className="detailed-info-content">
                <div className="info-header">
                  <h2>{product.detailedInfo.tagline}</h2>
                  <p className="info-subtitle">{product.detailedInfo.subtitle}</p>
                </div>
                <div className="info-overview">
                  <p>{product.detailedInfo.overview}</p>
                </div>
              </div>
            </div>
          </section>


          {/* Attendance Feature Section */}
          <section className="demo-attendance-feature">
            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
              <div className="attendance-feature-content">
                <div className="attendance-feature-text">
                  <h2>How ZipAccounts HRM Attendance Feature Works</h2>
                  <p>{product.detailedInfo.attendanceFeature}</p>
                  <div className="attendance-benefits">
                    <div className="attendance-benefit">
                      <i className="fa fa-clock-o"></i>
                      <span>Real-time Attendance Tracking</span>
                    </div>
                    <div className="attendance-benefit">
                      <i className="fa fa-mobile"></i>
                      <span>Mobile-Friendly Interface</span>
                    </div>
                    <div className="attendance-benefit">
                      <i className="fa fa-bar-chart"></i>
                      <span>Detailed Reports & Analytics</span>
                    </div>
                    <div className="attendance-benefit">
                      <FontAwesomeIcon icon={faFingerprint} style={{ color: '#5386df' }} />
                      <span>Biometric Integration</span>
                    </div>
                  </div>
                </div>
                <div className="attendance-feature-image">
                  {productId === 'hr-management' ? (
                    <img src="/img/Demos/HR2.png" alt="HRM Attendance Feature" />
                  ) : (
                    <img src={product.image} alt="Attendance System" />
                  )}
                </div>
              </div>
            </div>
          </section>
        </>
      )}

      <Footer data={landingPageData.footer} />
    </div>
  );
};

export default DemoPage; 